(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sia-cart"] && !Shopify.designMode) return;
  try {
    
  class SiaOrderCart extends HTMLElement {
    static plan(cart, eligibleIds, feeId, language) {
      const eligible = cart.items.some(item => eligibleIds.has(String(item.product_id)) && String(item.variant_id) !== String(feeId));
      const wanted = eligible && language !== 'English';
      const fees = cart.items.filter(item => String(item.variant_id) === String(feeId));
      const updates = {};
      fees.forEach((item, index) => {
        const quantity = wanted && index === 0 ? 1 : 0;
        if (item.quantity !== quantity) updates[item.key] = quantity;
      });
      return { updates, add: wanted && fees.length === 0, language: eligible ? language : 'English', wanted };
    }
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-status]');
      this.form.addEventListener('submit', event => this.submit(event));
    }
    async request(path, body) {
      const response = await fetch(this.dataset.cartUrl + path, {
        method: body ? 'POST' : 'GET',
        headers: { 'Accept':'application/json', ...(body ? { 'Content-Type':'application/json' } : {}) },
        credentials:'same-origin', cache:'no-store',
        ...(body ? { body:JSON.stringify(body) } : {})
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(this.dataset.error);
      return result;
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy) return;
      const checkout = event.submitter?.dataset.action === 'checkout';
      if (checkout && this.dataset.ready !== 'true') return;
      const early = this.querySelector('[data-early-start]');
      const acknowledgement = this.querySelector('[data-early-ack]');
      if (early.checked !== acknowledgement.checked) {
        this.status.textContent = this.querySelector('[data-consent-error]').dataset.consentError;
        (early.checked ? acknowledgement : early).focus();
        return;
      }
      const consent = {
        'Early start request': early.checked ? early.parentElement.innerText.trim() : 'Not requested — arrange start after withdrawal period',
        'Withdrawal acknowledgement': acknowledgement.checked ? acknowledgement.parentElement.innerText.trim() : 'Not given',
        'Early start policy version': '2026-09-14',
        'Early start choice recorded at': new Date().toISOString(),
        'Early start language': document.documentElement.lang,
        'Early start confirmation': 'Confirm by email before early work begins'
      };
      const selector = this.querySelector('[data-order-language]');
      const language = selector?.value || 'English';
      if (selector && !Array.from(selector.options).some(option => option.value === language && !option.disabled)) return;
      const eligibleIds = new Set(Array.from(this.querySelectorAll('[data-eligible="true"]'), row => row.dataset.productId));
      const feeId = this.dataset.feeId;
      if (language !== 'English' && !feeId) return;
      const quantities = {};
      for (const input of this.querySelectorAll('[data-line-key]')) {
        const value = Number(input.value);
        if (String(input.value).trim() === '' || !Number.isInteger(value) || value < 0) { input.reportValidity(); return; }
        quantities[input.dataset.lineKey] = value;
      }
      this.busy = true;
      this.status.textContent = this.dataset.working;
      this.querySelectorAll('button').forEach(button => button.disabled = true);
      try {
        let cart = await this.request('/update.js', { updates:quantities });
        let plan = SiaOrderCart.plan(cart, eligibleIds, feeId, language);
        if (Object.keys(plan.updates).length) cart = await this.request('/update.js', { updates:plan.updates });
        if (plan.add) {
          await this.request('/add.js', { items:[{ id:Number(feeId), quantity:1, properties:{ 'Delivery language':plan.language } }] });
          cart = await this.request('.js');
        }
        const fee = cart.items.find(item => String(item.variant_id) === String(feeId));
        if (plan.wanted && fee && fee.properties?.['Delivery language'] !== plan.language) {
          cart = await this.request('/change.js', { id:fee.key, quantity:1, properties:{ ...fee.properties, 'Delivery language':plan.language } });
        }
        consent['Early start items'] = cart.items.map(item => item.key + ':' + item.quantity + ';').join('');
        cart = await this.request('/update.js', { attributes:{ ...consent, 'Delivery language':plan.language, 'Translation scope':plan.wanted ? 'One translation add-on for all eligible check-ups in this order' : 'English reference language included' } });
        const feeQuantity = cart.items.filter(item => String(item.variant_id) === String(feeId)).reduce((sum, item) => sum + item.quantity, 0);
        if (Object.entries(consent).some(([key, value]) => (cart.attributes[key] ?? '') !== value)) throw new Error(this.dataset.error);
        if (feeQuantity !== (plan.wanted ? 1 : 0) || cart.attributes['Delivery language'] !== plan.language) throw new Error(this.dataset.error);
        if (checkout && cart.item_count > 0) {
          const form = document.createElement('form');
          form.method = 'POST'; form.action = this.dataset.cartUrl;
          const input = document.createElement('input');
          input.type = 'hidden'; input.name = 'checkout'; input.value = 'Checkout';
          form.append(input); document.body.append(form); form.submit();
        } else { window.location.reload(); }
      } catch (error) {
        this.status.textContent = this.dataset.error;
        this.busy = false;
        this.querySelectorAll('button').forEach(button => button.disabled = button.dataset.action === 'checkout' && this.dataset.ready !== 'true');
      }
    }
  }
  if (!customElements.get('sia-order-cart')) customElements.define('sia-order-cart', SiaOrderCart);

  } catch(e) { console.error(e); }
})();
})();
